<template>
    <rkm-area
        no-margin-top
        title="Problemas e/ou condições - EMAD"
        type="fieldset"
    >
        <rkm-row v-if="item.avaliacao.condicoesEmad.length > 0">
            <rkm-col cols="12">
                <Item :get-value="() => item.avaliacao.condicoesEmad.join(', ')" />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>